<div style="text-align: center">
    <button
        mat-icon-button
        [disabled]="favorites?.length < 1"
        [ngClass]="{ 'active-route': isActiveRoute() }"
        [matMenuTriggerFor]="menu">
        <mat-icon
            [class.star-toggle--filled]="favorites?.length > 0"
            [style.transform]="'scale(' + (isMenuNameVisible ? '.8' : '1.2') + ')'">
            grade
        </mat-icon>
    </button>
    @if (isMenuNameVisible) {
        <p style="font-size: 0.7em">Favoriten</p>
    }
</div>
<mat-menu #menu="matMenu">
    @for (f of favorites; track f) {
        <button mat-menu-item (click)="navigate(f)">
            <mat-icon color="accent">{{ f?.global ? "public" : "star" }}</mat-icon>
            <span>{{ f?.name }}</span>
        </button>
    }
</mat-menu>
